// extracted by mini-css-extract-plugin
export default {"root":"NavBar_root__WH0th","links":"NavBar_links__NkRle","link":"NavBar_link__baBCe","current":"NavBar_current__HZlVZ","right":"NavBar_right__J2Rh7","tips":"NavBar_tips__Bd0ly"};